import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnPrimary } from "@/components/Form";
import AuthCard from "@/components/AuthCard";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { toast.error("As senhas não conferem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw.a });
      toast.success("Senha redefinida! Entre com a nova senha."); nav("/login");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (!token) return <AuthCard eyebrow="Recuperar acesso" title="Link inválido" desc="Solicite um novo link de redefinição."><Link to="/esqueci-senha" className="font-semibold text-amber-700">Pedir novo link</Link></AuthCard>;
  return (
    <AuthCard eyebrow="Recuperar acesso" title="Criar nova senha" desc="Escolha uma nova senha com pelo menos 6 caracteres.">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="reset-new-password-input" required minLength={6} type="password" placeholder="Nova senha" className={inputCls} value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} />
        <input data-testid="reset-confirm-password-input" required minLength={6} type="password" placeholder="Confirmar nova senha" className={inputCls} value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} />
        <button data-testid="reset-submit-btn" disabled={busy} className={`${btnPrimary} w-full`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}Salvar nova senha</button>
      </form>
    </AuthCard>
  );
}
